import React from 'react';
import ApiKeysTable from '../components/tables/ApiKeysTable';

const ApiKeys: React.FC = () => {
  return <ApiKeysTable />;
};

export default ApiKeys;
